import React from 'react'

import { Popover } from 'antd'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import { Button, Checkbox, Drawer, Input, InputGroup, Loader } from 'rsuite'

import { Divider, IconButton, Stack } from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'

import css from './accessLevelUmkd.module.scss'
import { BootstrapTooltip } from '../../../../_ui/tooltip'
import Empty from '../../../../_ui/empty'
import emptyDoc from './../../../../../img/empty_documents.svg'

const AccessLevelUmkd = (props: any) => {
    return (
        <Drawer autoFocus={false} size="full" open={props.getAccessLevelUmkdVisible} onClose={() => props.onClickCloseEditAccessLevel()}>
            <div className={css.main}>
                <div className={css.mainHeader}>
                    <div className={css.headerTitle}>Редактирование уровней доступа УМКД</div>

                    <div className={css.headerBar}>
                        <BootstrapTooltip title="Закрыть" placement="bottom" arrow>
                            <IconButton size="medium" sx={{ color: "#5763b3", m: "auto 0" }} onClick={() => props.onClickCloseEditAccessLevel()}>
                                <CloseOutlinedIcon />
                            </IconButton>
                        </BootstrapTooltip>
                    </div>
                </div>

                <div className={css.mainBody}>
                    <OperatorAccessLevels {...props} />

                    <div className={css.bodyContent}>
                        <div className={css.contentHead}>
                            <div className={css.headTitle}>Уровни доступа для назначения</div>

                            <div className={css.headBar}>
                                <Button size="md" color="blue" appearance="primary" onClick={props.onClickButtonAdd}>
                                    ДОБАВИТЬ ВЫБРАННЫЕ НАПРАВЛЕНИЯ
                                </Button>
                            </div>
                        </div>

                        <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

                        <div className={css.contentSecondary}>
                            <DirectionTraining {...props} />
                            <Specialization {...props} />
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}


// Уровни доступа оператора
const OperatorAccessLevels = (props: any) => {
    return (
        <div className={css.bodyContent}>
            <div className={css.contentHead}>
                <div className={css.headTitle}>Уровни доступа оператора ({props.levelUmkdList.length})</div>
                <div className={css.headBar}></div>
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <div className={css.contentPrimary}>
                <div className={css.thead}>
                    <div></div>
                    <div>Напрвления подготовки</div>
                    <div></div>
                    <div>Специализации</div>
                    <div></div>
                </div>

                <div className={css.tbody}>
                    {props.isVisibleLoaderLevelsOperator
                        ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /></div>
                        : !props.levelUmkdList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="200px" heightImg="150px" />
                            : props.levelUmkdList.map((umkd: any) => {
                                return (
                                    <div key={umkd.umkd_access_level_id} className={css.trow}>
                                        <div style={{ margin: "auto 0", textAlign: "center" }}>{umkd.direction_training_id}</div>
                                        <div style={{ margin: "auto 0" }}>{umkd.direction_training_name}</div>
                                        <div style={{ margin: "auto 0", textAlign: "center" }}>{umkd.educational_program_id}</div>
                                        <div style={{ margin: "auto 0" }}>{umkd.educational_program_name}</div>

                                        <div style={{ textAlign: "right" }}>
                                            <Popover placement="bottomRight" trigger="click"
                                                content={
                                                    <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                        <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600", color: "#3c457d" }}>
                                                            Удалить уровень доступа?
                                                        </div>

                                                        <Button size="md" color="blue" appearance="primary"
                                                            onClick={() => props.onClickButtonDelete(
                                                                umkd.direction_training_id, umkd.direction_training_name,
                                                                umkd.educational_program_id, umkd.educational_program_name
                                                            )}
                                                        >ДА</Button>
                                                    </Stack>
                                                }>

                                                <div>
                                                    <BootstrapTooltip title="Удалить" placement="left" arrow>
                                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                            <DeleteOutlinedIcon />
                                                        </IconButton>
                                                    </BootstrapTooltip>
                                                </div>
                                            </Popover>
                                        </div>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

// Направления подгтовки для выбора
const DirectionTraining = (props: any) => {
    return (
        <div className={css.secondaryItem}>
            <div className={css.contentHead}>
                <div className={css.headTitle}>Направления подготовки ({props.dictDirectionTrainingList.length})</div>

                <div className={css.headBar}>
                    <InputGroup inside style={{ width: "280px" }} disabled={props.dictDirectionTrainingList.length ? false : true}>
                        <InputGroup.Addon>
                            <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                        </InputGroup.Addon>

                        <Input type="text" size="md" placeholder="Фильтр направлений ..."
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getFilterDirectionTraining}
                            onChange={value => props.setFilterDirectionTraining(value)}
                        />

                        {props.getFilterDirectionTraining &&
                            <InputGroup.Addon onClick={() => props.clearFilterValues('directionTraining')} style={{ margin: "-7px -7px 0 0" }}>
                                <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                    <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                        <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                </BootstrapTooltip>
                            </InputGroup.Addon>
                        }
                    </InputGroup>
                </div>
            </div>

            <div className={css.itemContent}>
                <div className={css.itemDataRow}>
                    {props.isVisibleLoaderDirectionTraining
                        ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /></div>
                        : !props.dictDirectionTrainingList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="200px" heightImg="150px" />
                            : props.dictDirectionTrainingList.filter((val: any) => {
                                let stringReturn

                                let name = val.name.toLowerCase().includes(props.getFilterDirectionTraining.toLowerCase())

                                if (name) {
                                    stringReturn = val
                                }

                                return stringReturn
                            }).map((training: any) => {
                                return (
                                    <div key={training.id}
                                        className={training.isSelected ? css.trainingRowActive : css.trainingRow}
                                        onClick={() => props.onClickDirectionTraining(training.id)}
                                    >{training.name}</div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

// Специализации для выбора
const Specialization = (props: any) => {
    return (
        <div className={css.secondaryItem}>
            <div className={css.contentHead}>
                <div className={css.headTitle}>Специализации ({props.dictEducationalProgramList.length})</div>

                <div className={css.headBar}>
                    <InputGroup inside style={{ width: "280px" }} disabled={props.dictEducationalProgramList.length ? false : true}>
                        <InputGroup.Addon>
                            <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                        </InputGroup.Addon>

                        <Input type="text" size="md" placeholder="Фильтр специализаций ..."
                            autoComplete="off" style={{ paddingRight: "40px" }}
                            value={props.getFilterEducationalProgram}
                            onChange={value => props.setFilterEducationalProgram(value)}
                        />

                        {props.getFilterEducationalProgram &&
                            <InputGroup.Addon onClick={() => props.clearFilterValues('specialization')} style={{ margin: "-7px -7px 0 0" }}>
                                <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                    <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                        <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                </BootstrapTooltip>
                            </InputGroup.Addon>
                        }
                    </InputGroup>
                </div>
            </div>

            <div className={css.itemContent}>
                <Checkbox
                    className={css.checkStyle}
                    indeterminate={props.checkedAllCount > 0 && props.checkedAllCount !== props.dictEducationalProgramList.length}
                    checked={props.dictEducationalProgramList.length ? props.checkedAllCount === props.dictEducationalProgramList.length : false}
                    disabled={props.dictEducationalProgramList.length ? false : true}
                    onChange={(value, checked) => props.onChangeSelectedAllSpecialization(checked)}
                >Выбрать все специализации</Checkbox>

                <div className={css.itemDataRow}>
                    {props.isVisibleLoaderSpecialization
                        ? <div style={{ height: "100%", position: "relative" }}><Loader center size="md" content="Загрузка данных..." vertical /></div>
                        : !props.dictEducationalProgramList.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="200px" heightImg="150px" />
                            : props.dictEducationalProgramList.filter((val: any) => {
                                let stringReturn

                                let name = val.name.toLowerCase().includes(props.getFilterEducationalProgram.toLowerCase())

                                if (name) {
                                    stringReturn = val
                                }

                                return stringReturn
                            }).map((program: any) => {
                                return (
                                    <div key={program.id} className={css.specializationRow}>
                                        <Checkbox
                                            value={program.id}
                                            checked={program.isSelected}
                                            onChange={(value, checked) => props.onChangeSpecialization(value, checked)}
                                        >{program.name}</Checkbox>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}

export default AccessLevelUmkd